import { useEffect } from 'react'
import * as Yup from 'yup'
import { useAppTranslation } from 'src/admin/core/hooks'
import { useParams } from 'react-router-dom'
import { ProgramOwner } from '../../models'
import { useProgramOwner } from './useProgramOwner'

const initialValues: ProgramOwner = {
  id: '',
  name: '',
  trainerId: undefined,
  active: true,
}

export const useFormHandler = () => {
  const { label } = useAppTranslation()
  const { id } = useParams()
  const { owner, loading, getProgramOwner } = useProgramOwner()

  useEffect(() => {
    if (id) {
      getProgramOwner(id)
    }
  }, [id])

  const formSchema = Yup.object().shape({
    name: Yup.string().required(label('REQUERIDO')),
    trainerId: Yup.string().nullable().required(label('REQUERIDO')),
  })

  return {
    loading,
    formSchema,
    initialValues: owner || initialValues,
  }
}
